import { Component } from 'react';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { FeatureFlagService, FeatureFlagServiceProps, LocalizedText, withFeatureFlagService } from '@mews/framework';
import { FieldsContainer } from '@mews-commander/ui';
import { email, InputField, presence, RadioGroupField, SelectField, TextareaField } from '@mews-commander/legacy-form';

interface Props {
    languageOptions?: $TSFixMe[]; // TODO: pt.shape
    nationalityOptions?: $TSFixMe[]; // TODO: pt.shape
    showCustomEmail?: boolean;
    featureFlagService: FeatureFlagService;
}

class EmailSendForm extends Component<Props & FeatureFlagServiceProps> {
    render() {
        const {
            // @ts-expect-error $TSFixMeError: Property 'mailTypeOptions' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            mailTypeOptions,
            // @ts-expect-error $TSFixMeError: Property 'receiverOptions' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            receiverOptions,
            languageOptions,
            showCustomEmail,
            // @ts-expect-error $TSFixMeError: Property 'onMailTypeOptionChange' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            onMailTypeOptionChange,
            // @ts-expect-error $TSFixMeError: Property 'onReceiverOptionChange' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            onReceiverOptionChange,
            // @ts-expect-error $TSFixMeError: Property 'onSuccess' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            onSuccess,
            // @ts-expect-error $TSFixMeError: Property 'onSubmitFail' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            onSubmitFail,
            featureFlagService,
            ...other
        } = this.props;

        const handleMailTypeOptionChange = (ev: $TSFixMe) => onMailTypeOptionChange(ev.target.value);
        const handleReceiverOptionChange = () => onReceiverOptionChange();

        const customMessageEnabled = featureFlagService.hasFlag(FeatureFlag.mailTemplateEditorCustomMessageEnabled);

        return (
            <FieldsContainer {...other}>
                <RadioGroupField {...mailTypeProps} onChange={handleMailTypeOptionChange} options={mailTypeOptions} />
                <SelectField {...receiverProps} onChange={handleReceiverOptionChange} options={receiverOptions} />
                {showCustomEmail && <InputField {...customEmailProps} />}
                <SelectField {...languageProps} options={languageOptions} />
                {customMessageEnabled && <TextareaField {...customMessageProps} />}
            </FieldsContainer>
        );
    }
}

const mailTypeProps = {
    label: <LocalizedText textKey={TextKey.Type} />,
    name: 'mailType',
    filterable: true,
};

const receiverProps = {
    label: <LocalizedText textKey={TextKey.Receiver} />,
    name: 'receiver',
    filterable: false,
};

const customEmailProps = {
    label: <LocalizedText textKey={TextKey.Email} />,
    name: 'customEmail',
};

const customMessageProps = {
    label: <LocalizedText textKey={TextKey.MailTemplateCustomMessage} />,
    name: 'customMessage',
};

const languageProps = {
    label: <LocalizedText textKey={TextKey.PreferredLanguage} />,
    name: 'languageCode',
    filterable: true,
    showEmptyValue: true,
};

export const constraints = {
    mailType: {
        presence,
    },
    receiver: {
        presence,
    },
    customEmail: {
        presence,
        email,
    },
};
export default withFeatureFlagService(EmailSendForm);
